// extracted by mini-css-extract-plugin
export default {"spin":"SpinningIcon_spin__QD7xr"};